import { MoveStruct, normalizeMoveArguments } from "../utils/index.mjs";
import { bcs } from "@safecoin/safe/bcs";
new MoveStruct({
	name: `@local-pkg/kiosk::personal_kiosk_rule::Rule`,
	fields: { dummy_field: bcs.bool() }
});
/** Add the "owned" rule to the KioskOwnerCap. */
function add(options) {
	const packageAddress = options.package ?? "@local-pkg/kiosk";
	const argumentsTypes = [null, null];
	const parameterNames = ["policy", "cap"];
	return (tx) => tx.moveCall({
		package: packageAddress,
		module: "personal_kiosk_rule",
		function: "add",
		arguments: normalizeMoveArguments(options.arguments, argumentsTypes, parameterNames),
		typeArguments: options.typeArguments
	});
}
/**
* Make sure that the destination Kiosk has the Owner key. Item is already placed
* by the time this check is performed - otherwise fails.
*/
function prove(options) {
	const packageAddress = options.package ?? "@local-pkg/kiosk";
	const argumentsTypes = [null, null];
	const parameterNames = ["kiosk", "request"];
	return (tx) => tx.moveCall({
		package: packageAddress,
		module: "personal_kiosk_rule",
		function: "prove",
		arguments: normalizeMoveArguments(options.arguments, argumentsTypes, parameterNames),
		typeArguments: options.typeArguments
	});
}
//#endregion
export { add, prove };

//# sourceMappingURL=personal_kiosk_rule.mjs.map